import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { LearningObjectiveEvent } from "./../shared/model/events";
import { LearningObjective } from "./../shared/model/model";
@Component({
  selector: "app-learning-objective-view",
  styleUrls: ["learning-objective-view.component.scss"],
  templateUrl: "learning-objective-view.component.html",
  standalone: true,
  imports: [CommonModule],
})
export class LearningObjectiveViewComponent {
  @Input() learningObjective: LearningObjective;
  @Input() readOnly = true;
  @Output() selectLearningObjective =
    new EventEmitter<LearningObjectiveEvent>();
  @Input() selected = false;

  domainIcons: any = {
    "meten & meetkunde": "./assets/domainicons/DomainIcons_3.svg",
    verhoudingen: "./assets/domainicons/DomainIcons_2.svg",
    getallen: "./assets/domainicons/DomainIcons_1.svg",
    verbanden: "./assets/domainicons/verbanden.svg",
    "meten & meetkunde_opdracht": "./assets/domainicons/DomainIcons_6.svg",
    verhoudingen_opdracht: "./assets/domainicons/DomainIcons_5.svg",
    getallen_opdracht: "./assets/domainicons/DomainIcons_4.svg",
    verbanden_opdracht: "./assets/domainicons/verbanden_opdracht.svg",
  };

  domainabbreviations: any = {
    "meten & meetkunde": "MT",
    verhoudingen: "VH",
    getallen: "GT",
    verbanden: "VB",
    werkwoorden: "WW",
    weetwoorden: "WTW",
    regelwoorden: "RW",
    klankwoorden: "KW",
  };

  public learningObjectiveSelected = () =>
    this.selectLearningObjective.emit({
      learningObjectiveId: this.learningObjective.id,
      learningObjectiveCode: this.learningObjective.code,
    });

  public getAbbreviation = (d: LearningObjective) =>
    this.domainabbreviations[d.domainTitle.toLowerCase()];
}
